<script>
import baseMixin from '@/mixins/baseMixin'
import { mapActions } from 'vuex'
import { getType } from 'mime'
import { isNullOrEmptyArray } from '@/helpers/array-helpers'

export default {
  name: 'FormSubmissionDownloadPdfBtn',
  mixins: [baseMixin],
  props: {
    passkey: {
      type: String,
      default: '',
    },
  },
  data: () => {
    return {
      isLoading: false,
      urls: [],
    }
  },
  computed: {
    hasPasskey() {
      return !!this.passkey
    },
  },
  beforeDestroy() {
    this.revokePdfObjUrls()
  },
  methods: {
    ...mapActions({
      generatePdf: 'forms/generatePdf',
    }),
    revokePdfObjUrls() {
      if (isNullOrEmptyArray(this.urls)) return

      for (const url of this.urls) {
        if (!url) continue
        window.URL.revokeObjectURL(url)
      }
    },
    async downloadPdf() {
      if (!this.hasPasskey) return

      this.isLoading = true

      const result = await this.generatePdf(this.passkey)

      if (result.isSuccess) {
        // Handles scenario if content-disposition header is missing
        const pdfFileData = new Blob([result.data.blob], {
          type: getType(`${this.passkey}.pdf`),
        })

        // Create a URL for the Blob object
        const url = URL.createObjectURL(pdfFileData)

        // Cache URL so that it may be revoked later
        this.urls.push(url)

        // Open the Blob object in a new tab
        window.open(url, '_blank')
      }

      this.isLoading = false
    },
  },
}
</script>

<template>
  <v-tooltip :disabled="!hasPasskey" top>
    <template v-slot:activator="{ on, attrs }">
      <BaseButton
        v-if="hasPasskey"
        icon
        :loading="isLoading"
        v-bind="attrs"
        @click="downloadPdf"
        v-on="on"
      >
        <v-icon>mdi-download</v-icon>
      </BaseButton>
    </template>
    <span class="ws-pre-wrap">{{ $t('forms.pdf.downloadTooltip') }}</span>
  </v-tooltip>
</template>
